import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { RecommendTsApi, RecommendTsRequest, RecommendTsResponse, ConfirmTsRequest, ConfirmTsResponse } from '../recommend-ts-api';
import { GuestAwareHttpService } from '../../services/guest-aware-http-service';

@injectable()
export class RecommendTsApiImpl extends GuestAwareHttpService implements RecommendTsApi {
    async getRecommendTs(request: RecommendTsRequest): Promise<RecommendTsResponse> {
        const res = await this.postWithGuestSupport<RecommendTsResponse>(
            {
                data: request,
            },
            'recommend_ts'
        );
        return res;
    }

    async confirmTs(request: ConfirmTsRequest): Promise<ConfirmTsResponse> {
        const res = await this.postWithGuestSupport<ConfirmTsResponse>(
            {
                data: request,
            },
            'recommend_ts/confirm'
        );
        return res;
    }
}
